/**
 * Finishing - Sponsors
 *
 * JS pour la gestion des sponsors
 *
 * @since       02.11.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {
    
    /**************************************/
    /********** SLIDER INSTAGRAM **********/
    /**************************************/
    
    if ( jQuery( '.sponsors-slider-wrapper' ).length > 0 ) {
        
        jQuery( function() {
            jQuery( ".sponsors-slider" ).responsiveSlides({
                speed: 400
            });
        });
     
    //END if ( jQuery( '.sponsors-slider-wrapper' ).length > 0 )
    }

//END jQuery(document).ready
});
